import {HttpContextToken, HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import { clearSessionToken, getSessionToken } from '../utils/session-token';

export const BYPASS_JW_TOKEN = new HttpContextToken(() => false);

export const Interceptor: HttpInterceptorFn = (req, next) => {

  if (req.context.get(BYPASS_JW_TOKEN) === false) {
    const session = getSessionToken();
    const cloneReq = session
      ? req.clone({
          setHeaders: {
            'Session-Token': `${session}`
          }
        })
      : req.clone();
    return next(cloneReq).pipe(
      catchError((err:any) => {
        if(err.status != 401 && err.status != 403){

        }else if(err instanceof HttpErrorResponse){
          clearSessionToken()
          window.location.assign('/#/authentication/login')
        }
        return throwError(() => err);
      })
    );

  }else{
    const cloneReq = req.clone();
    return next(cloneReq).pipe(
      catchError((err:any) => {
        if(err == 500){
        }else if(err instanceof HttpErrorResponse){
          clearSessionToken()
        }
        return throwError(() => err);
      })
    );

  }
};
